import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import * as auth from 'core/auth';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
import { FlightPassengerEditComponent } from 'src/components/flight/passenger-edit';
import { required, minLength } from 'vuelidate/lib/validators';
import { SegmentModel } from 'core/flights';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

export function returnBeforeDate(value) {
    console.log('value=' + value);
    return false;
}

@WithRender
@Component({
    components: {
        'passenger-edit': FlightPassengerEditComponent
    },
    validations: {
        signInModel: {
            email: { required, minLength: minLength(5) },
            password: { required, minLength: minLength(6) }
        }
    }
})
export class FlightsBookingPassengersComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    flightBookingDetails: api.FlightBookingDetails;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];

    @Prop()
    searchParams: flights.FlightSearchParams;

    @Prop()
    toolbarPrice: number;

    @Prop()
    v: any;

    signInModel = {
        email: '',
        password: '',
        submitted: false
    }

    toolbarPriceClass: string = '';

    showFullFlightBrandDescription: boolean[] = [];

    get freezePlace(): string {
        if (this.flightBookingDetails && this.flightBookingDetails?.prebookingTimeLimitMinutes
            && !this.gaAlreadySubmitted.includes('flights.booking.info.freeze.place')) {
            (<any>this).$ga.sendEvent('flights.booking', 'info.freeze.place', 'flights.booking.info.freeze.place', this.gaParams);

            this.gaAlreadySubmitted.push('flights.booking.info.freeze.place');
        }
        return i18next.t('label_freeze_place', { i: this.flightBookingDetails ? this.flightBookingDetails?.prebookingTimeLimitMinutes : 0 });
    }

    get hasFreeBaggage(): boolean {
        return utils.Baggage.hasFreeBaggage(this.reservation.selectedFlight!);
    }

    get customBaggageLable(): string {
        if (this.reservation.customBaggagePrice > 0) {
            return `${i18next.t('label_additional_baggage')}: <b>${this.$options.filters!.price(this.reservation.customBaggagePrice)}</b>`;
        } else {
            return i18next.t('label_baggage_select');
        }
    }

    get totalPassengers() {
        return this.searchParams.passengers.adults
            + this.searchParams.passengers.children
            + this.searchParams.passengers.infants;
    }

    get bookingClassName() {
        return flights.BookingClass.classLabel(this.searchParams.class);
    }

    get productsForPassengersStep() {
        return this.reservation.productsNotGrouped.filter(({ product }) =>
            product.stepNumber === 1 && (product.flightId == this.reservation.selectedFlightIdForProducts || product.flightId == null)
        );
    }

    get stepOneBrands(){
        if(this.reservation.brandedProductKits){
            return this.reservation.brandedProductKits.find((brands) =>
                brands.stepOnForm === 1 && brands.kitTarget !== 'AdditionalPopup'
            );
        }
    }

    get seatsLeftWarning() {
        return i18next.t('label_seats_left_warning', <any>{ i: i18next.t('numerous_seat', <any>{ count: this.reservation.passengers.length }) });
    }

    mounted() {
        this.reservation.flights.forEach(() => {
            this.showFullFlightBrandDescription.push(false);
        });
        if (this.reservation.flights && this.reservation.flights.length > 1 && !this.$parent.$data.modalBrandChoiceShowedOnce) {
            this.$parent.$data.modalBrandChoiceShowedOnce = true;
            (<any>this.$refs).modalBrandChoice.show();
        }
    }

    validatePassengerByIndexAndUpsertFFDCookie(index: number) {
        const passenger = this.reservation.passengers[index];
        let passengerIsFullfilled = !!passenger.gender
            && !!passenger.lastName
            && !!passenger.firstName
            && !!passenger.birthday
            && !!passenger.documentNumber;

        if (!passenger.documentValidTillVisible) {
            passengerIsFullfilled = passengerIsFullfilled && !!passenger.middleName;
        }
        if (passenger.documentValidTillVisible) {
            passengerIsFullfilled = passengerIsFullfilled && !!passenger.documentValidTill;
        }
        if (passengerIsFullfilled) {
            const vPassenger = this.v.passengers.$each[index];

            let passengerIsValid = !vPassenger.gender.$error
                && !vPassenger.lastName.$error
                && !vPassenger.firstName.$error
                && !vPassenger.birthday.$error
                && !vPassenger.documentNumber.$error;

            if (!passenger.documentValidTillVisible) {
                passengerIsValid = passengerIsValid && !vPassenger.middleName.$error;
            }
            if (passenger.documentValidTillVisible) {
                passengerIsValid = passengerIsValid && !vPassenger.documentValidTill.$error;
            }
            if (passengerIsValid) {
                const passengers: (flights.PassengerModel | null)[] = [];

                this.reservation.passengers.forEach((passengerElement, passengerInedx) => {
                    if (index == passengerInedx) {
                        passengers.push(passengerElement);
                    } else {
                        passengers.push(null);
                    }
                });
                utils.Cookies.g2sFFDUpsert({ passengers });
            }
        }
    }

    getBaggageOptions(baggageItems: api.CustomBaggageItem[]): any {
        const result: {
            label: string;
            value: string;
        }[] = [];

        baggageItems.forEach((baggage: api.CustomBaggageItem) => {
            const item: {
                label: string;
                value: string;
            } = {
                label: i18next.t('label_baggage_without_additional'),
                value: baggage.id
            };

            if (baggage.bagsQuantity > 0) {
                item.label = i18next.t('numerous_baggage_piece', <any>{ count: baggage.bagsQuantity });
                if (baggage.bagsWeight && baggage.bagsWeight != '0') {
                    item.label += ' (' + baggage.bagsWeight + ' ' + i18next.t('label_kg') + ')';
                }
                if (baggage.price > 0) {
                    item.label += ': ' + (<any>this.$options.filters).price(baggage.price);
                } else {
                    item.label += ': ' + i18next.t('label_price_free');
                }
            }

            result.push(item);
        });

        return result;
    }

    getPassengerLabelByIndex(index: number) {
        if (this.reservation.passengers[index].firstName
            || this.reservation.passengers[index].middleName
            || this.reservation.passengers[index].lastName) {
            return this.reservation.passengers[index].middleName
                ? `${this.reservation.passengers[index].firstName} ${this.reservation.passengers[index].middleName} ${this.reservation.passengers[index].lastName}`
                : `${this.reservation.passengers[index].firstName} ${this.reservation.passengers[index].lastName}`;
        } else {
            return i18next.t('label_passenger_with_number', { i: index + 1 });
        }
    }

    getDestinationNameById(id) {
        const destination = this.flightBookingDetails.destinations[id];
        let destinationName = '';

        if (destination && destination.city && destination.city.localizedName) {
            destinationName = destination.city.localizedName;
        }

        if (destinationName) {
            return destinationName;
        } else {
            return '';
        }
    }

    getBaggageLabel(flight: flights.FlightModel) {
        return utils.Baggage.getLabel(flight.legs[0].baggage, false);
    }

    getBaggageShortLabel(flightBaggage: api.FlightBaggage, isCabin: boolean): string {
        let label = utils.Baggage.getLabel(flightBaggage, isCabin);

        if (label == i18next.t('label_baggage_without')) {
            label = i18next.t('label_baggage_without_short');
        }
        if (label == i18next.t('label_baggage_cabin_without')) {
            label = i18next.t('label_baggage_cabin_without_short');
        }

        return label;
    }

    getSegmentBaggageLabelByCustomBaggageOption(customBaggageOption: api.CustomBaggageOption) {
        if (this.reservation.selectedFlight) {
            const foundedSegment = this.reservation.selectedFlight.legs
                .map(leg => leg.segments)
                .reduce((memo, value) => memo.concat(value), [])
                .find(segment =>
                    segment.departureDestination.uniqueId == Number(customBaggageOption.destinationFromUID)
                    && segment.arrivalDestination.uniqueId == Number(customBaggageOption.destinationToUID));

            if (foundedSegment) {
                if (utils.Baggage.getBaggageValue(foundedSegment) == i18next.t('label_baggage_without_short')) {
                    return `${utils.Baggage.getBaggageValue(foundedSegment)}`;
                } else {
                    return `${utils.Baggage.getBaggageValue(foundedSegment)} ${i18next.t('label_baggage_on_passenger').toLowerCase()}`;
                }
            }
        }

        return '';
    }

    getSegmentBaggageCabinLabelByCustomBaggageOption(customBaggageOption: api.CustomBaggageOption) {
        if (this.reservation.selectedFlight) {
            const foundedSegment = this.reservation.selectedFlight.legs
                .map(leg => leg.segments)
                .reduce((memo, value) => memo.concat(value), [])
                .find(segment =>
                    segment.departureDestination.uniqueId == Number(customBaggageOption.destinationFromUID)
                    && segment.arrivalDestination.uniqueId == Number(customBaggageOption.destinationToUID));

            if (foundedSegment) {
                if (utils.Baggage.getBaggageCabinValue(foundedSegment) == i18next.t('label_baggage_cabin_without_short')) {
                    return `${utils.Baggage.getBaggageCabinValue(foundedSegment)}`;
                } else {
                    return `${utils.Baggage.getBaggageCabinValue(foundedSegment)} ${i18next.t('label_baggage_on_passenger').toLowerCase()}`;
                }
            }
        }

        return '';
    }

    getSegmentCustomBaggageLabelByCustomBaggageOptionIndex(index: number) {
        if (this.reservation.selectedFlight
            && this.reservation.selectedFlight.customBaggage.options
            && this.reservation.selectedFlight.customBaggage.options.length) {
            const currentCustomBaggageOption = this.reservation.selectedFlight.customBaggage.options[index];

            if (currentCustomBaggageOption.baggageOptions
                && currentCustomBaggageOption.baggageOptions.length) {
                let result = 0;

                if (currentCustomBaggageOption.baggageOptions[0].perPassenger) {
                    this.reservation.passengersForBaggage.forEach(passenger => {
                        const relativeCustomBaggageItemId = passenger.baggageOptions[index];
                        const founedCustomBaggageItem = currentCustomBaggageOption.baggageOptions.find(
                            customBaggageItem => customBaggageItem.id == relativeCustomBaggageItemId
                        );

                        if (founedCustomBaggageItem
                            && founedCustomBaggageItem.bagsQuantity
                            && founedCustomBaggageItem.bagsWeight) {
                            result += founedCustomBaggageItem.bagsQuantity * Number(founedCustomBaggageItem.bagsWeight);
                        }
                    });
                } else {
                    this.reservation.baggageOptions.forEach(customBaggageItemId => {
                        const founedCustomBaggageItem = this.reservation.getAvailableCustomBaggageItems()
                            .find(customBaggageItem => customBaggageItem.id == customBaggageItemId);

                        if (founedCustomBaggageItem
                            && founedCustomBaggageItem.bagsQuantity
                            && founedCustomBaggageItem.bagsWeight) {
                            result += founedCustomBaggageItem.bagsQuantity * Number(founedCustomBaggageItem.bagsWeight);
                        }
                    });
                }
                return result;
            }
        }

        return '';
    }

    getSegmentCustomBaggageSummaryLabel(segmentFirst: flights.SegmentModel, segmentLast: flights.SegmentModel) {
        if (this.reservation.selectedFlight
            && this.reservation.selectedFlight.customBaggage
            && this.reservation.selectedFlight.customBaggage.options
            && this.reservation.selectedFlight.customBaggage.options.length) {
            const relativeCustomBaggageOption = this.reservation.selectedFlight.customBaggage.options.find(
                customBaggageOption =>
                    Number(customBaggageOption.destinationFromUID) == segmentFirst.departureDestination.uniqueId
                    && Number(customBaggageOption.destinationToUID) == segmentLast.arrivalDestination.uniqueId
            );

            if (relativeCustomBaggageOption) {
                return this.getSegmentCustomBaggageLabelByCustomBaggageOptionIndex(
                    this.reservation.selectedFlight.customBaggage.options.indexOf(relativeCustomBaggageOption)
                );
            }
        }

        return '';
    }

    getSegmentBaggageSummaryLabel(segment: flights.SegmentModel) {
        return utils.Baggage.getBaggageValue(segment);
    }

    onPassengerChange() {
        this.$emit('change');
    }

    onBaggageChange() {
        const oldBaggageChoiceType = this.reservation.baggageChoiceType;

        if (this.reservation.hasSelectedAnyCustomBaggage) {
            this.reservation.baggageChoiceType = api.BaggageChoiceType.manualAccepted;
        } else {
            this.reservation.baggageChoiceType = api.BaggageChoiceType.manualDenied;
        }

        console.log('baggageChoiceType ' + oldBaggageChoiceType + ' > ' + this.reservation.baggageChoiceType);
    }

    onBaggageOpen() {
        (<any>this.$refs).modalBaggage.show();
    }

    onBaggageClose() {
        const oldBaggagePrice = this.reservation.customBaggagePrice;

        (<any>this.$refs).modalBaggage.hide();

        if (oldBaggagePrice != this.reservation.customBaggagePrice) {
            if (this.gaAlreadySubmitted.indexOf('flights.booking.baggage.changed') < 0) {
                (<any>this).$ga.sendEvent('flights.booking', 'baggage.changed', 'flights.booking.baggage.changed', this.gaParams);

                this.gaAlreadySubmitted.push('flights.booking.baggage.changed');
            }
        }
    }

    onSignIn() {
        (<any>this.$refs).modalSignIn.show();

        if (this.gaAlreadySubmitted.indexOf('flights.booking.user.signin.click') < 0) {
            (<any>this).$ga.sendEvent('flights.booking', 'user.signin.click', 'flights.booking.user.signin.click', this.gaParams);

            this.gaAlreadySubmitted.push('flights.booking.user.signin.click');
        }
    }

    onSignInSubmit() {
        if (this.signInModel.submitted) {
            return;
        }

        this.$v.signInModel!.$touch();

        if (this.$v.signInModel!.$error) {
            (<any>this.$root.$refs).messageDialog.show({
                message: i18next.t('error_fields')
            });
            (<any>this).$ga.sendEvent('flights.booking', 'user.signin.error', 'flights.booking.user.signin.error', this.gaParams);
        } else {
            this.signInModel.submitted = true;

            this.$auth.signIn(this.signInModel.email, this.signInModel.password).then(
                (result: api.User) => {
                    this.signInModel.submitted = false;

                    if (!this.reservation.contacts.email) {
                        this.reservation.contacts.email = result.email!;
                    }
                    if (!this.reservation.contacts.phone) {
                        this.reservation.contacts.phone = result.phone!;
                    }

                    this.$emit('signin');

                    (<any>this.$refs).modalSignIn.hide();

                    if (this.gaAlreadySubmitted.indexOf('flights.booking.user.signin.success') < 0) {
                        (<any>this).$ga.sendEvent('flights.booking', 'user.signin.success', 'flights.booking.user.signin.success', this.gaParams);

                        this.gaAlreadySubmitted.push('flights.booking.user.signin.success');
                    }
                },
                (error) => {
                    this.signInModel.submitted = false;

                    (<any>this).$ga.sendEvent('flights.booking', 'user.signin.error', 'flights.booking.user.signin.error', this.gaParams);
                    (<any>this.$root.$refs).messageDialog.show({
                        message: error?.response?.data?.localizedMessage ? error.response.data.localizedMessage : i18next.t('error_server_tryagain')
                    });

                    if (error.response) {
                        console.log('XHR failed', error.response.status, error.response.data);
                    } else {
                        console.log('XHR error', error.message);
                    }
                }
            );
        }
    }

    onContactsEmailBlur() {
        this.v.contacts.email.$touch();
        if (this.reservation.contacts.email) {
            if (!this.v.contacts.email.$error) {
                utils.Cookies.g2sFFDUpsert({ email: this.reservation.contacts.email });
            }
        }
    }

    onContactsPhoneBlur() {
        this.v.contacts.phone.$touch();
        if (this.reservation.contacts.phone) {
            if (!this.v.contacts.phone.$error) {
                utils.Cookies.g2sFFDUpsert({ phone: this.reservation.contacts.phone });
            }
        }
    }

    onSubmit() {
        this.v.passengers.$touch();
        this.v.contacts.$touch();

        let title: any = i18next.t('error');
        let error = '';

        if (this.v.passengers.$error || this.v.contacts.$error) {
            if (!error
                && !this.v.contacts.email.required) {
                error = i18next.t('error_email_empty');
                if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                    (<any>this).$ga.sendEvent('flights.booking', 'step1.email.error', 'flights.booking.step1.email.error', this.gaParams);
                }
            }

            if (!error
                && !this.v.contacts.email.email) {
                error = i18next.t('error_email_wrong');
                if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                    (<any>this).$ga.sendEvent('flights.booking', 'step1.email.error', 'flights.booking.step1.email.error', this.gaParams);
                }
            }

            if (!error
                && !this.v.contacts.phone.required) {
                error = i18next.t('error_phone_empty');
                if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                    (<any>this).$ga.sendEvent('flights.booking', 'step1.phone.error', 'flights.booking.phone.error', this.gaParams);
                }
            }

            if (!error
                && !this.v.contacts.phone.validatePhone) {
                error = i18next.t('error_phone_wrong');
                if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                    (<any>this).$ga.sendEvent('flights.booking', 'step1.phone.error', 'flights.booking.phone.error', this.gaParams);
                }
            }

            this.reservation.passengers.forEach((passenger, index) => {
                if (!error) {
                    if (!error
                        && !this.v.passengers.$each[index].lastName.validatePassengerName) {
                        error = i18next.t('error_name_last_wrong');
                        if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                            (<any>this).$ga.sendEvent('flights.booking', 'step1.surname.error', 'flights.booking.step1.surname.error', this.gaParams);
                        }
                    }
                    if (!error
                        && this.v.passengers.$each[index].lastName.$error) {
                        error = i18next.t('error_name_last_wrong');
                        if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                            (<any>this).$ga.sendEvent('flights.booking', 'step1.surname.error', 'flights.booking.step1.surname.error', this.gaParams);
                        }
                    }
                    if (!error
                        && !this.v.passengers.$each[index].firstName.validatePassengerName) {
                        error = i18next.t('error_name_first_wrong');
                        if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                            (<any>this).$ga.sendEvent('flights.booking', 'step1.name.error', 'flights.booking.step1.name.error', this.gaParams);
                        }
                    }
                    if (!error
                        && this.v.passengers.$each[index].firstName.$error) {
                        error = i18next.t('error_name_first_wrong');
                        if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                            (<any>this).$ga.sendEvent('flights.booking', 'step1.name.error', 'flights.booking.step1.name.error', this.gaParams);
                        }
                    }
                    if (!error) {
                        if (!this.v.passengers.$each[index].middleName.validatePassengerNameLast) {
                            error = i18next.t('error_name_middle_required');
                            if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                                (<any>this).$ga.sendEvent('flights.booking', 'step1.patronymic.error', 'flights.booking.step1.patronymic.error', this.gaParams);
                            }
                        }
                        if (!error
                            && this.v.passengers.$each[index].middleName.$error) {
                            error = i18next.t('error_name_middle_wrong');
                            if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                                (<any>this).$ga.sendEvent('flights.booking', 'step1.patronymic.error', 'flights.booking.step1.patronymic.error', this.gaParams);
                            }
                        }
                    }
                    if(!error
                        && this.v.passengers.$each[index].gender.$error) {
                        error = i18next.t('error_gender_not_selected');
                        if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                            (<any>this).$ga.sendEvent('flights.booking', 'step1.gender.error', 'flights.booking.step1.gender.error', this.gaParams);
                        }
                    }
                    
                    if (!error
                        && !this.v.passengers.$each[index].birthday.validateBirthday) {
                        if (passenger.type === 'adult') {
                            if (!this.v.passengers.$each[index].birthday.validateBirthdayMin) {
                                error = i18next.t('error_birthday_adult_old');
                            } else {
                                error = i18next.t('error_birthday_adult_wrong');
                            }
                        }
                        else if (passenger.type === 'child') {
                            error = i18next.t('error_birthday_child_wrong');
                        }
                        else if (passenger.type === 'infant') {
                            error = i18next.t('error_birthday_infant_wrong');
                        }
                        if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                            (<any>this).$ga.sendEvent('flights.booking', 'step1.date.birth.error', 'flights.booking.step1.date.birth.error', this.gaParams);
                        }
                    }
                    if (!error
                        && this.v.passengers.$each[index].birthday.$error) {
                        error = i18next.t('error_birthday_empty');
                        if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                            (<any>this).$ga.sendEvent('flights.booking', 'step1.date.birth.error', 'flights.booking.step1.date.birth.error', this.gaParams);
                        }
                    }
                    if (!error) {
                        if (!this.v.passengers.$each[index].citizenship.isCitizenshipAccept) {
                            error = i18next.t('error_citizenship_wrong_fare');
                        }
                        if (!error
                            && this.v.passengers.$each[index].citizenship.$error
                            || !this.v.passengers.$each[index].citizenship.isCitizenshipFilled) {
                            error = i18next.t('error_citizenship_empty');
                            (<any>this).$ga.sendEvent('flights.booking', 'step1.citizenship.error', 'flights.booking.step1.citizenship.error', this.gaParams);
                        }
                    }
                    if (!error
                        && this.v.passengers.$each[index].documentNumber.$error) {
                        if (!error
                            && !this.v.passengers.$each[index].documentNumber.required) {
                            error = i18next.t('error_document_number_empty');
                        }
                        if (!error
                            && !this.v.passengers.$each[index].documentNumber.minLength) {
                            error = i18next.t('error_document_number_too_short');
                        }
                        if (!error
                            && !this.v.passengers.$each[index].documentNumber.maxLength) {
                            error = i18next.t('error_document_number_too_long');
                        }
                        if (!error
                            && !this.v.passengers.$each[index].documentNumber.validateCertificateArmenia) {
                            error = 'Оформление билетов возможно только по заграничному паспорту.';
                        }
                        if (!error
                            && !this.v.passengers.$each[index].documentNumber.validateCertificateAge) {
                            error = 'Cтарше 14 лет. Введите серию, номер российского паспорта или заграничного паспорта РФ.';
                        }
                        if (!error
                            && !this.v.passengers.$each[index].documentNumber.validateDocumentForeign) {
                            error = 'Для заграничного паспорта РФ введите 9 цифр или выберите другое гражданство.';
                        }
                        if (!error
                            && !this.v.passengers.$each[index].documentNumber.validateCertificateSymbol) {
                            error = i18next.t('error_document_certificate_notvalid');
                        }
                        if (!error
                            && !this.v.passengers.$each[index].documentNumber.validateDocumentNumber) {
                            error = i18next.t('error_document_number_notvalid');
                        }
                        if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                            (<any>this).$ga.sendEvent('flights.booking', 'step1.passport.error', 'flights.booking.step1.passport.error', this.gaParams);
                        }
                    }
                    if (!error
                        && !this.v.passengers.$each[index].documentValidTill.validateDocumentValidTill) {
                        error = i18next.t('error_document_valid_till_wrong', <any>{ i: passenger.validationConstraints.minDocumentValidTill.format('L') });
                        if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                            (<any>this).$ga.sendEvent('flights.booking', 'step1.passport.date.error', 'flights.booking.step1.passport.date.error', this.gaParams);
                        }
                    }
                    if (!error
                        && this.v.passengers.$each[index].cardAirlineId.$error) {
                        error = i18next.t('error_passenger_card_airline_id_required');
                        if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                            (<any>this).$ga.sendEvent('flights.booking', 'step1.card.miles.error', 'flights.booking.step1.card.miles.error', this.gaParams);
                        }
                    }
                    if (!error
                        && this.v.passengers.$each[index].card.$error) {
                        if (!this.v.passengers.$each[index].card.maxLength) {
                            error = i18next.t('error_passenger_card_maxlength');
                        } else if (!this.v.passengers.$each[index].card.onlyOneUniqueCard) {
                            error = i18next.t('error_passenger_card_used_more_than_once');
                        }
                        if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                            (<any>this).$ga.sendEvent('flights.booking', 'step1.card.miles.error', 'flights.booking.step1.card.miles.error', this.gaParams);
                        }
                    }

                    if (error) {
                        error = i18next.t('label_passenger_with_number', <any>{ i: index + 1 }) + ': ' + error;
                    }
                }
            });

            if (!error
                && !this.v.passengers.validationPassengersBirthday) {
                error = i18next.t('error_has_adult_wrong');
                if (this.gaAlreadySubmitted.includes('flights.booking.input.started')) {
                    (<any>this).$ga.sendEvent('flights.booking', 'step1.passengers.error', 'flights.booking.passengers.error', this.gaParams);
                }
            }

            if (!error) {
                title = undefined; // Hide title
                error = i18next.t('error_fields');
            }

            (<any>this.$root.$refs).messageDialog.show({
                title: title,
                message: error
            });

            if (this.gaAlreadySubmitted.indexOf('flights.booking.step1.error') < 0) {
                (<any>this).$ga.sendEvent('flights.booking', 'step1.error', 'flights.booking.step1.error', this.gaParams);
                (<any>this).$ga.reachGoal('flights.booking.step1.error');

                this.gaAlreadySubmitted.push('flights.booking.step1.error');
            }
        } else {
            this.$emit('submit');
        }
    }

    onCloseBrandChoiceModalClick(action: string) {
        if(action) {
            (<any>this).$ga.sendEvent('flights.booking', `btn.brands.${action}`, `flights.booking.btn.brands.${action}`, this.gaParams);
        }

        (<any>this.$refs).modalBrandChoice.hide();
    }

    onBrandChoiceItemClick(flight: flights.FlightModel, index: number) {
        this.$emit('brand-accum', index, flight.uniqueId);
        const brandSelectNum = this.gaAlreadySubmitted.includes('flights.booking.btn.brands') ? '2' : '';
        if (flight.billingPrice > this.reservation.selectedFlightBillingPrice) {
            this.$emit('brand-change', 'upgrade' + brandSelectNum);
        } else if (flight.billingPrice < this.reservation.selectedFlightBillingPrice) {
            this.$emit('brand-change', 'downgrade' + brandSelectNum);
        }

        this.toolbarPriceClass = '';
        this.reservation.selectedFlightId = flight.uniqueId;

        setTimeout(() => {
            this.toolbarPriceClass = 'bounce-in';
        }, 0);

        if (this.reservation.defaultFlight
            && this.reservation.defaultFlight.uniqueId == flight.uniqueId) {
            this.reservation.brandChoiceType = api.FlightBrandChoiceType.manualDefault;
        } else {
            this.reservation.brandChoiceType = api.FlightBrandChoiceType.manualUpgrade;
        }
    }
    onBrandGroupSelect(brandGroupIndex: number, flight: flights.FlightModel) {
        const brandSelectNum = this.gaAlreadySubmitted.includes('flights.booking.btn.brands') ? '2' : '';
        if (flight.billingPrice > this.reservation.brandGroups[brandGroupIndex].selectedFlight!.billingPrice) {
            this.reservation.brandGroups[brandGroupIndex].brandChangeState = 'upgrade' + brandSelectNum;
        } else if (flight.billingPrice < this.reservation.brandGroups[brandGroupIndex].selectedFlight!.billingPrice) {
            this.reservation.brandGroups[brandGroupIndex].brandChangeState = 'downgrade' + brandSelectNum;
        }

        this.toolbarPriceClass = '';
        this.reservation.brandGroups[brandGroupIndex].selectedFlightId = flight.uniqueId;

        setTimeout(() => {
            this.toolbarPriceClass = 'bounce-in';
        }, 0);

        if (this.reservation.brandGroups[brandGroupIndex].defaultFlightId === flight.uniqueId) {
            this.reservation.brandChoiceType = api.FlightBrandChoiceType.manualDefault;
        } else {
            this.reservation.brandChoiceType = api.FlightBrandChoiceType.manualUpgrade;
        }

        if (this.reservation.flights.length > 1
            && this.reservation.brandGroups[brandGroupIndex].selectedFlightId !== this.reservation.brandGroups[brandGroupIndex].defaultFlightId) {
            const brandNum = this.gaAlreadySubmitted.includes('flights.booking.btn.brands') ? '2' : '';
            if (!this.gaAlreadySubmitted.includes('flights.booking.brands.changed' + brandNum + brandGroupIndex)) {
                (<any>this).$ga.sendEvent('flights.booking', 'brands.changed' + brandNum, 'flights.booking.brands.changed' + brandNum, this.gaParams);
                this.gaAlreadySubmitted.push('flights.booking.brands.changed' + brandNum + brandGroupIndex);
            }
        }
    }

    onBrandShowMoreClick(index: number) {
        this.showFullFlightBrandDescription[index] = !this.showFullFlightBrandDescription[index];
        this.$forceUpdate();
    }

    onShowModalBrandChoiceClick() {
        if (this.reservation.flights && this.reservation.flights.length > 1) {
            if(!this.gaAlreadySubmitted.includes('flights.booking.btn.brands')) {
                (<any>this).$ga.sendEvent('flights.booking', 'btn.brands', 'flights.booking.btn.brands', this.gaParams);
                this.gaAlreadySubmitted.push('flights.booking.btn.brands');
            }
            (<any>this.$refs).modalBrandChoice.show();
        }
    }

    onProductDetails(product: flights.ProductModel) {
        this.$emit('product-details', product);
    }

    onProductSelectionChange(product: flights.ProductModel, value: boolean) {
        this.$emit('product-selection-change', product, value);
    }

    onFlightTerms() {
        if (this.reservation.selectedFlight) {
            this.$emit('flight-terms', this.reservation.selectedFlight.uniqueId);
        }
    }
}
